module.exports = __webpack_public_path__ + "img/c02_buildingdevineproduction_Normal_ua.994f00d5.webp";